@if (showLoader && !inRoom()) {
  <div class="loading-container">
    <app-loading></app-loading>
  </div>
}

@if (badgeQuestions) {
  <div>
    @if (badgingForm) {
      <form [formGroup]="badgingForm">
        <div class="badging-card">
          <div class="scroll-bar" [style]="{ maxHeight: inRoom() && '45vh' }">
            @if (shouldShowHeader(requiredBadgeQuestions)) {
              <div>
                <div class="card-title">
                  <span>Required</span>
                </div>
                @for (question of requiredBadgeQuestions; track question) {
                  @if (!!question) {
                    <div [ngStyle]="{ marginBottom: !!question.description ? '20px' : '15x' }">
                      <!-- Form field of type input -->
                      @if (questionTypeInput(question.inputType)) {
                        <mat-form-field class="badging-form" appearance="outline">
                          <mat-label>{{ question.title }}</mat-label>
                          <input
                            type="text"
                            attr.aria-label="{{ question.title }}"
                            placeholder="{{ question.title }}"
                            formControlName="{{ question.title }}"
                            matInput
                            required
                            id="{{ 'badge-' + question.title }}"
                            (focus)="scrollIntoFieldView('badge-' + question.title)"
                          />
                          <mat-hint>
                            {{ question.description }}
                          </mat-hint>
                          <mat-error>
                            {{ inputErrorMessage(question) }}
                          </mat-error>
                        </mat-form-field>
                      }
                      <!-- Form field of type text area -->
                      @if (questionTypeTextArea(question.inputType)) {
                        <mat-form-field class="badging-form" appearance="outline">
                          <mat-label>{{ question.title }}</mat-label>
                          <textarea
                            id="{{ 'badge-' + question.title }}"
                            type="text"
                            attr.aria-label="{{ question.title }}"
                            placeholder="{{ question.title }}"
                            formControlName="{{ question.title }}"
                            matInput
                            required
                            (focus)="scrollIntoFieldView('badge-' + question.title)"
                          ></textarea>
                          @if (!inputErrorMessage(question)) {
                            <ng-container>
                              <mat-hint align="end">
                                {{ getQuestionFormValue(question.title).length }} / 2000
                              </mat-hint>
                              <mat-hint>
                                {{ question.description }}
                              </mat-hint>
                            </ng-container>
                          }
                          <mat-error>
                            <div class="textarea-error-message">
                              {{ inputErrorMessage(question) }}
                              {{ getQuestionFormValue(question.title).length }} / 2000
                            </div>
                          </mat-error>
                        </mat-form-field>
                      }
                      <!-- Form field of type single select -->
                      @if (questionTypeSingleSelect(question.inputType)) {
                        <mat-form-field class="badging-form" appearance="outline">
                          <mat-label>{{ question.title }}</mat-label>
                          <mat-select
                            attr.aria-label="{{ question.title }}"
                            placeholder="{{ question.title }}"
                            formControlName="{{ question.title }}"
                            matInput
                            required
                            id="{{ 'badge-' + question.title }}"
                            (focus)="scrollIntoFieldView('badge-' + question.title)"
                          >
                            @for (item of question.options; track item) {
                              <mat-option [value]="item">{{ item }}</mat-option>
                            }
                          </mat-select>
                          <mat-hint>
                            {{ question.description }}
                          </mat-hint>
                          <mat-error>
                            {{ inputErrorMessage(question) }}
                          </mat-error>
                        </mat-form-field>
                      }
                      <!-- Form field of type multi select -->
                      @if (questionTypeMultiSelect(question.inputType)) {
                        <mat-form-field class="badging-form" appearance="outline">
                          <mat-label>{{ question.title }}</mat-label>
                          <mat-select
                            attr.aria-label="{{ question.title }}"
                            placeholder="{{ question.title }}"
                            formControlName="{{ question.title }}"
                            multiple
                            matInput
                            required
                            id="{{ 'badge-' + question.title }}"
                            (focus)="scrollIntoFieldView('badge-' + question.title)"
                          >
                            @for (item of question.options; track item) {
                              <mat-option class="badge-option" [value]="item">{{ item }}</mat-option>
                            }
                          </mat-select>
                          <mat-hint>
                            {{ question.description }}
                          </mat-hint>
                          <mat-error>
                            {{ inputErrorMessage(question) }}
                          </mat-error>
                        </mat-form-field>
                      }
                      <!-- From field of type number -->
                      @if (questionTypeNumber(question.inputType)) {
                        <mat-form-field class="badging-form" appearance="outline">
                          <mat-label>{{ question.title }}</mat-label>
                          <input
                            type="input"
                            inputmode="numeric"
                            pattern="\d*"
                            attr.aria-label="{{ question.title }}"
                            placeholder="{{ question.title }}"
                            formControlName="{{ question.title }}"
                            matInput
                            required
                            id="{{ 'badge-' + question.title }}"
                            (focus)="scrollIntoFieldView('badge-' + question.title)"
                          />
                          <mat-hint>
                            {{ question.description }}
                          </mat-hint>
                          <mat-error>
                            {{ inputErrorMessage(question) }}
                          </mat-error>
                        </mat-form-field>
                      }
                    </div>
                  }
                }
              </div>
            }
            @if (shouldShowHeader(optionalBadgeQuestions)) {
              <div>
                <div class="card-title">
                  <span>Optional</span>
                </div>
                @for (question of optionalBadgeQuestions; track question) {
                  <div [ngStyle]="{ marginBottom: !!question.description ? '20px' : '15px' }">
                    <!-- Form field of type input -->
                    @if (questionTypeInput(question.inputType)) {
                      <mat-form-field class="badging-form" appearance="outline">
                        <mat-label>{{ question.title }}</mat-label>
                        <input
                          type="text"
                          attr.aria-label="{{ question.title }}"
                          placeholder="{{ question.title }}"
                          formControlName="{{ question.title }}"
                          matInput
                          id="{{ 'badge-' + question.title }}"
                          (focus)="scrollIntoFieldView('badge-' + question.title)"
                        />
                        <mat-hint>
                          {{ question.description }}
                        </mat-hint>
                        <mat-error>
                          {{ inputErrorMessage(question) }}
                        </mat-error>
                      </mat-form-field>
                    }
                    <!-- Form field of type text area -->
                    @if (questionTypeTextArea(question.inputType)) {
                      <mat-form-field class="badging-form" appearance="outline">
                        <mat-label>{{ question.title }}</mat-label>
                        <textarea
                          type="text"
                          attr.aria-label="{{ question.title }}"
                          placeholder="{{ question.title }}"
                          formControlName="{{ question.title }}"
                          matInput
                          id="{{ 'badge-' + question.title }}"
                          (focus)="scrollIntoFieldView('badge-' + question.title)"
                        ></textarea>
                        <mat-hint align="end"> {{ getQuestionFormValue(question.title).length }} / 2000 </mat-hint>
                        <mat-hint>
                          {{ question.description }}
                        </mat-hint>
                        <mat-error>
                          <div class="textarea-error-message">
                            {{ inputErrorMessage(question) }}
                            <span> {{ getQuestionFormValue(question.title).length }} / 2000 </span>
                          </div>
                        </mat-error>
                      </mat-form-field>
                    }
                    <!-- Form field of type single select -->
                    @if (questionTypeSingleSelect(question.inputType)) {
                      <mat-form-field class="badging-form" appearance="outline">
                        <mat-label>{{ question.title }}</mat-label>
                        <mat-select
                          attr.aria-label="{{ question.title }}"
                          placeholder="{{ question.title }}"
                          formControlName="{{ question.title }}"
                          matInput
                          id="{{ 'badge-' + question.title }}"
                          (focus)="scrollIntoFieldView('badge-' + question.title)"
                        >
                          @for (item of question.options; track item) {
                            <mat-option [value]="item">{{ item }}</mat-option>
                          }
                        </mat-select>
                        <mat-hint>
                          {{ question.description }}
                        </mat-hint>
                        <mat-error>
                          {{ inputErrorMessage(question) }}
                        </mat-error>
                      </mat-form-field>
                    }
                    <!-- Form field of type multi select -->
                    @if (questionTypeMultiSelect(question.inputType)) {
                      <mat-form-field class="badging-form" appearance="outline">
                        <mat-label>{{ question.title }}</mat-label>
                        <mat-select
                          attr.aria-label="{{ question.title }}"
                          placeholder="{{ question.title }}"
                          formControlName="{{ question.title }}"
                          multiple
                          matInput
                          id="{{ 'badge-' + question.title }}"
                          (focus)="scrollIntoFieldView('badge-' + question.title)"
                        >
                          @for (item of question.options; track item) {
                            <mat-option class="badge-option" [value]="item">{{ item }}</mat-option>
                          }
                        </mat-select>
                        <mat-hint>
                          {{ question.description }}
                        </mat-hint>
                        <mat-error>
                          {{ inputErrorMessage(question) }}
                        </mat-error>
                      </mat-form-field>
                    }
                    <!-- From field of type number -->
                    @if (questionTypeNumber(question.inputType)) {
                      <mat-form-field class="badging-form" appearance="outline">
                        <mat-label>{{ question.title }}</mat-label>
                        <input
                          type="input"
                          inputmode="numeric"
                          pattern="\d*"
                          attr.aria-label="{{ question.title }}"
                          placeholder="{{ question.title }}"
                          formControlName="{{ question.title }}"
                          matInput
                          id="{{ 'badge-' + question.title }}"
                          (focus)="scrollIntoFieldView('badge-' + question.title)"
                        />
                        <mat-hint>
                          {{ question.description }}
                        </mat-hint>
                        <mat-error>
                          {{ inputErrorMessage(question) }}
                        </mat-error>
                      </mat-form-field>
                    }
                  </div>
                }
              </div>
            }
          </div>
          <div class="button-div">
            <button
              extended
              id="continue-btn"
              type="submit"
              class="join-scootaverse-button"
              data-testid="continue-btn"
              [ngStyle]="{ background: event?.buttonColor, color: event?.buttonTextColor }"
              [ngClass]="{ 'event-button-style': !!event?.buttonColor }"
              [class.disabled]="!badgingForm.valid && badgingForm.touched"
              [disabled]="(!badgingForm.valid && badgingForm.touched) || showLoader"
              (click)="submitBadgingForm()"
            >
              @if (showLoader) {
                <mat-spinner color="white" [diameter]="25"></mat-spinner>
              } @else {
                {{ buttonText() }}
              }
            </button>
          </div>
          @if (hasRequiredError) {
            <div class="required-message-wrapper">
              <p class="required-text">
                Complete all <strong>Required*</strong> Fields {{ inRoom() ? '' : 'to enter the Scootaverse' }}
              </p>
            </div>
          }
        </div>
      </form>
    }
  </div>
}
